import React, { useEffect, useState } from 'react';
import BodyContainer from '../ui/BodyContainer';
import EventCard from '../ui/EventCard';
import Services from '../services/services';
import Loader from '../ui/Loader';
import event1 from '../assets/event1.png';
import { Toaster } from 'react-hot-toast';
import { getUserBrowserStorage } from '../constants';

function HomePage() {
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    getListOfEvents();
  }, []);

  const getListOfEvents = () => {
    userDetails?.userId || setLoader(false);
    userDetails?.userId &&
      Services.list_events_controlled(userDetails?.userId)
        .then((res) => {
          setLoader(false);
          setData(res.data.listOfHostEvents);
          return null;
        })
        .catch((err) => {
          setLoader(false);
          return null;
        });
  };

  return (
    <BodyContainer title="My Events">
      {data.map((each) => {
        return (
          <EventCard
            data={each}
            key={each.eventId}
            image={event1}
            userType={userDetails?.userType}
            userId={userDetails?.userId}
          />
        );
      })}
      <Loader open={loader} />
      <Toaster position="top-center" />
    </BodyContainer>
  );
}

export default HomePage;
